import { styled, Typography } from '@mui/material';

// import { Icon } from 'app/main/components';

const Root = styled('div')(({ theme }) => ({
	'& .logo-icon': {
		width: '30px',
		height: '30px',
		backgroundColor: theme.palette.secondary.main,
		WebkitMaskImage: 'url(assets/images/logo/perceptive-logo.svg)',
		maskImage: 'url(assets/images/logo/perceptive-logo.svg)',

		transition: theme.transitions.create(['width', 'height'], {
			duration: theme.transitions.duration.shortest,
			easing: theme.transitions.easing.easeInOut
		})
	},
	'& .logo-text': {
		transition: theme.transitions.create('opacity', {
			duration: theme.transitions.duration.shortest,
			easing: theme.transitions.easing.easeInOut
		})
	}
}));

function Logo() {
	return (
		<Root className="flex items-center">
			<div className="flex items-center">
				<div className="logo-icon" />
				<div className="logo-text ml-8">
					<Typography className="text-18 font-800" color="inherit">
						PERCEPTIVE
					</Typography>
					<Typography className="text-8 -mt-8 font-700 tracking-widest" color="secondary">
						HRM
					</Typography>
				</div>
			</div>
		</Root>
	);
}

export default Logo;
